function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'shared/components/Link';
import featureEnabled from 'shared/helper/feature';
import { getChinaLocalization } from 'shared/account/reducer';
import { T, useTranslate } from 'shared/helper/translate';
import { searchDigitalEdits } from 'researcher/digital-editing/actions';
import { getTotalEditsForTrialBanner } from 'researcher/digital-editing/reducer';
import { PADDLE_PLAN_TYPES } from '../constants';
import { TRIAL_CONVERSION_MODAL_SESSION, countTrialSession, dismissTrialConversionModal, isTrialConversionModalDismissed, trialSessionKey } from '../helpers/trialConversionSession';
import BillingToggle from './pricing/components/BillingToggle';
import PlanCard from './pricing/components/PlanCard';
import { PRIMARY_BUTTON, OUTLINE_BUTTON } from './pricing/components/buttonClasses';
import PaddleCheckoutButton from './pricing/row/PaddleCheckoutButton';
import usePurchaseCompletion from './pricing/row/usePurchaseCompletion';
import useRowPlanPricing from './pricing/row/useRowPlanPricing';
import useChinaPlanPricing from './pricing/china/useChinaPlanPricing';
import usePricingCopy from './pricing/usePricingCopy';
import { FEATURE_LIST_TERMS } from './pricing/pricingContent';
import './pricing/pricing.scss';
import './pricing/trial-conversion-modal.scss';
var SUPPORT_REQUEST_URL = {
  row: 'https://www.aje.com/submit-a-request',
  china: 'https://www.aje.cn/submit-a-request'
};
var ROW_PLANS = [{
  id: 'premium',
  planGroup: 'editing',
  analyticsName: 'Rubriq Premium',
  isPopular: true
}, {
  id: 'translation',
  planGroup: 'premiumWithTranslation',
  analyticsName: 'Rubriq Premium with Translation'
}];
var CHINA_PLANS = [{
  id: 'premium',
  planGroup: 'editingOnly',
  analyticsName: 'Rubriq Premium',
  cartPath: '/rubriq/subscribe/cart/editing',
  isPopular: true
}, {
  id: 'translation',
  planGroup: 'premiumWithTranslation',
  analyticsName: 'Rubriq Premium with Translation',
  cartPath: '/rubriq/subscribe/cart/translation',
  featureFlag: 'rubriq_china_cart_edit_only_plan'
}];
var CTA_TERM_BY_ID = {
  premium: 'curie.get-premium',
  translation: 'rubriq.pricing.get-premium-with-translation'
};
var TrialConversionModal = function TrialConversionModal(_ref) {
  var _curiePlans$free_tria, _curiePlans$premium;
  var _ref$deferred = _ref.deferred,
    deferred = _ref$deferred === void 0 ? false : _ref$deferred;
  var dispatch = useDispatch();
  var _useState = useState(PADDLE_PLAN_TYPES.YEARLY),
    _useState2 = _slicedToArray(_useState, 2),
    billingInterval = _useState2[0],
    setBillingInterval = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    sessionNumber = _useState4[0],
    setSessionNumber = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    dismissed = _useState6[0],
    setDismissed = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    usageRequestSettled = _useState8[0],
    setUsageRequestSettled = _useState8[1];
  var usageRequested = useRef(false);
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _usePricingCopy = usePricingCopy(),
    page = _usePricingCopy.page,
    plans = _usePricingCopy.plans;
  var _useRowPlanPricing = useRowPlanPricing(),
    getSubscriptionPricing = _useRowPlanPricing.getSubscriptionPricing;
  var _useChinaPlanPricing = useChinaPlanPricing(),
    getAnnualPricing = _useChinaPlanPricing.getAnnualPricing;
  var onPurchaseComplete = usePurchaseCompletion();
  var isChinaUser = useSelector(getChinaLocalization);
  var paddleBillingForChina = featureEnabled('rubriq_china_also_uses_paddle');
  var deepSeekEnabled = featureEnabled('rubriq_china_deep_seek');
  var cardlessTrialEnabled = featureEnabled('rubriq_cardless_free_trial');
  var useCartInsteadOfPaddle = isChinaUser && !paddleBillingForChina;
  var curieLoaded = useSelector(function (_ref2) {
    var curie = _ref2.curie;
    return curie === null || curie === void 0 ? void 0 : curie.loaded;
  });
  var curiePlans = useSelector(function (_ref3) {
    var curie = _ref3.curie;
    return curie === null || curie === void 0 ? void 0 : curie.plans;
  });
  var chinaTrial = (curiePlans === null || curiePlans === void 0 || (_curiePlans$free_tria = curiePlans.free_trial) === null || _curiePlans$free_tria === void 0 ? void 0 : _curiePlans$free_tria.status) === 'active' ? curiePlans.free_trial : null;
  var paddleTrial = (curiePlans === null || curiePlans === void 0 || (_curiePlans$premium = curiePlans.premium) === null || _curiePlans$premium === void 0 ? void 0 : _curiePlans$premium.paymentStatus) === 'trialing' ? curiePlans.premium : null;
  var activeTrial = chinaTrial !== null && chinaTrial !== void 0 ? chinaTrial : paddleTrial;
  var userIdentity = useSelector(function (_ref4) {
    var user = _ref4.user;
    return user.identity;
  });

  // For cardless trial upgrade: pass the existing subscription id through to Paddle
  var cardlessTrialSubscriptionId = useSelector(function (state) {
    var _state$curie;
    return (_state$curie = state.curie) === null || _state$curie === void 0 || (_state$curie = _state$curie.plan) === null || _state$curie === void 0 || (_state$curie = _state$curie.paddleSubscription) === null || _state$curie === void 0 ? void 0 : _state$curie.paddleId;
  });
  var isOnCardlessTrial = cardlessTrialEnabled && paddleTrial && cardlessTrialSubscriptionId;
  var documentCount = useSelector(function (_ref5) {
    var _curie$access$feature, _curie$access;
    var curie = _ref5.curie;
    return (_curie$access$feature = curie === null || curie === void 0 || (_curie$access = curie.access) === null || _curie$access === void 0 || (_curie$access = _curie$access.features) === null || _curie$access === void 0 || (_curie$access = _curie$access.editing) === null || _curie$access === void 0 ? void 0 : _curie$access.usesConsumed) !== null && _curie$access$feature !== void 0 ? _curie$access$feature : 0;
  });
  var totalEdits = useSelector(getTotalEditsForTrialBanner);
  var _useSelector = useSelector(function (_ref6) {
      var _digitalEdit$status;
      var digitalEdit = _ref6.digitalEdit;
      return (_digitalEdit$status = digitalEdit === null || digitalEdit === void 0 ? void 0 : digitalEdit.status) !== null && _digitalEdit$status !== void 0 ? _digitalEdit$status : {};
    }),
    searchBusy = _useSelector.searchBusy,
    searchCompleted = _useSelector.searchCompleted;
  var trialKey = cardlessTrialEnabled && activeTrial ? trialSessionKey({
    userIdentity: userIdentity,
    trialExpirationDate: activeTrial.endsAt
  }) : null;

  // Count this browser session as soon as we know which trial it belongs to.
  useEffect(function () {
    if (!trialKey) {
      return;
    }
    setSessionNumber(countTrialSession(trialKey));
    setDismissed(isTrialConversionModalDismissed(trialKey));
  }, [trialKey]);
  var isDue = !dismissed && sessionNumber >= TRIAL_CONVERSION_MODAL_SESSION;

  // The edits total comes from the documents list, which only the editing page
  // loads — fetch it ourselves when the modal is due on another page.
  useEffect(function () {
    if (!isDue || documentCount === 0 || searchCompleted || searchBusy || usageRequested.current) {
      return;
    }
    usageRequested.current = true;
    var settle = function settle() {
      return setUsageRequestSettled(true);
    };
    dispatch(searchDigitalEdits({
      page: 1
    })).then(settle, settle);
  }, [isDue, documentCount, searchCompleted, searchBusy]);
  var usageLoaded = documentCount === 0 || searchCompleted || usageRequestSettled;
  var handleClose = function handleClose() {
    dismissTrialConversionModal(trialKey);
    setDismissed(true);
  };
  var getCardPricing = function getCardPricing(planGroup) {
    if (isChinaUser) {
      var _getAnnualPricing = getAnnualPricing(planGroup),
        plan = _getAnnualPricing.plan,
        price = _getAnnualPricing.price,
        _yearlySavings = _getAnnualPricing.yearlySavings;
      return {
        plan: plan,
        amount: plan === null || plan === void 0 ? void 0 : plan.price,
        price: price,
        period: page.perYear,
        savings: _yearlySavings
      };
    }
    var _getSubscriptionPrici = getSubscriptionPricing(planGroup, billingInterval),
      selectedPlan = _getSubscriptionPrici.selectedPlan,
      amount = _getSubscriptionPrici.amount,
      monthlyPrice = _getSubscriptionPrici.monthlyPrice,
      yearlySavings = _getSubscriptionPrici.yearlySavings;
    return {
      plan: selectedPlan,
      amount: amount,
      price: monthlyPrice,
      period: page.perMonth,
      savings: yearlySavings
    };
  };
  var _getSubscriptionPrici2 = getSubscriptionPricing(ROW_PLANS[0].planGroup, billingInterval),
    discountPercent = _getSubscriptionPrici2.discountPercent;

  // Reuse the same translated term + params pattern as the TrialUsageBanner.
  var documents = t(documentCount === 1 ? 'trial-banner-document' : 'trial-banner-documents', {
    count: documentCount
  });
  var changes = t(totalEdits === 1 ? 'trial-banner-change' : 'trial-banner-changes', {
    count: totalEdits
  });
  var renderAction = function renderAction(_ref7) {
    var id = _ref7.id,
      analyticsName = _ref7.analyticsName,
      cartPath = _ref7.cartPath,
      plan = _ref7.plan,
      amount = _ref7.amount;
    var className = id === 'premium' ? PRIMARY_BUTTON : OUTLINE_BUTTON;
    if (useCartInsteadOfPaddle) {
      return /*#__PURE__*/React.createElement(Link, {
        className: className,
        to: cartPath,
        onClick: handleClose
      }, t(CTA_TERM_BY_ID[id]));
    }
    return /*#__PURE__*/React.createElement(PaddleCheckoutButton, {
      paddlePlanId: plan === null || plan === void 0 ? void 0 : plan.paddlePlanId,
      className: className,
      upgradedFromSubscriptionId: isOnCardlessTrial ? cardlessTrialSubscriptionId : undefined,
      onClose: plan && onPurchaseComplete({
        plan: plan,
        amount: amount,
        productName: analyticsName
      })
    }, t(CTA_TERM_BY_ID[id]));
  };
  var renderPlanCard = function renderPlanCard(_ref8) {
    var id = _ref8.id,
      planGroup = _ref8.planGroup,
      analyticsName = _ref8.analyticsName,
      cartPath = _ref8.cartPath,
      isPopular = _ref8.isPopular;
    var _getCardPricing = getCardPricing(planGroup),
      plan = _getCardPricing.plan,
      amount = _getCardPricing.amount,
      price = _getCardPricing.price,
      period = _getCardPricing.period,
      savings = _getCardPricing.savings;
    return /*#__PURE__*/React.createElement(PlanCard, {
      key: id,
      title: plans[id].title,
      popularBadge: isPopular && page.popular,
      price: price,
      period: period,
      savingsNote: savings && page.savings(savings),
      featuresTerm: id === 'translation' && deepSeekEnabled ? FEATURE_LIST_TERMS.translationDeepseek : FEATURE_LIST_TERMS[id],
      action: renderAction({
        id: id,
        analyticsName: analyticsName,
        cartPath: cartPath,
        plan: plan,
        amount: amount
      })
    });
  };
  var pricingReady = !!getCardPricing(isChinaUser ? CHINA_PLANS[0].planGroup : ROW_PLANS[0].planGroup).plan;
  if (deferred || !curieLoaded || !pricingReady || !isDue || !usageLoaded) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Modal, {
    appElement: window.document.querySelector('#researcher-app') || document.body,
    className: "react-modal trial-conversion-modal",
    isOpen: true,
    overlayClassName: "react-modal-overlay trial-conversion-overlay",
    shouldCloseOnOverlayClick: false,
    onRequestClose: handleClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "rubriq-pricing trial-conversion-body"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "trial-conversion-close position-absolute border-0 bg-transparent p-0 lh-1",
    "aria-label": t('close'),
    onClick: handleClose
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/React.createElement("h2", {
    className: "trial-conversion-title fw-bold"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.trial-conversion-title"
  })), /*#__PURE__*/React.createElement("p", {
    className: "trial-conversion-subtext"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.trial-conversion-subtext"
  })), documentCount > 0 && /*#__PURE__*/React.createElement("div", {
    className: "trial-conversion-usage d-flex align-items-center gap-2"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-circle-check",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "trial-conversion-trial-banner",
    params: {
      documents: documents,
      changes: changes,
      upgradeRoute: '#'
    }
  })), !isChinaUser && /*#__PURE__*/React.createElement(BillingToggle, {
    options: [{
      value: PADDLE_PLAN_TYPES.MONTHLY,
      label: page.monthly
    }, {
      value: PADDLE_PLAN_TYPES.YEARLY,
      label: page.annual,
      badge: discountPercent > 0 ? page.discount(discountPercent) : null
    }],
    value: billingInterval,
    onChange: setBillingInterval
  }), /*#__PURE__*/React.createElement("div", {
    className: "pricing-cards d-flex"
  }, (isChinaUser ? CHINA_PLANS : ROW_PLANS).filter(function (_ref9) {
    var featureFlag = _ref9.featureFlag;
    return !featureFlag || featureEnabled(featureFlag);
  }).map(renderPlanCard)), /*#__PURE__*/React.createElement("div", {
    className: "trial-conversion-footer d-flex align-items-center justify-content-between gap-3"
  }, /*#__PURE__*/React.createElement("span", {
    className: "trial-conversion-help"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Need help choosing?"
  }), ' ', /*#__PURE__*/React.createElement("a", {
    href: isChinaUser ? SUPPORT_REQUEST_URL.china : SUPPORT_REQUEST_URL.row,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Contact support"
  }))), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "trial-conversion-remind border-0 bg-transparent p-0",
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(T, {
    source: "Remind me later"
  })))));
};
export default TrialConversionModal;